<template>
  <div>
    <div v-if="edit">
      <validation-observer
        :ref="'formValidator' + Math.floor(Math.random() * max)"
        v-slot="{ handleSubmit }"
      >
        <form method="post" @submit.prevent="handleSubmit(save)">
          <base-input-currency
            :inputId="'amountInput' + Math.floor(Math.random() * max)"
            prependChar="$"
            setFocus="true"
            name="Cycle Amount"
            rules="moneyZeroOk"
            v-model="innerValue"
          >
            <template #appendButton>
              <button class="btn btn-primary" type="submit">
                <i class="fas fa-save"></i>
              </button>
            </template>
          </base-input-currency>
        </form>
      </validation-observer>
    </div>
    <div v-else>
      <a href="#" @click.prevent="edit = true">{{ innerValue | currency }}</a>
    </div>
  </div>
</template>

<script>
export default {
  props: { value: null, context: null },
  data() {
    return {
      innerValue: null,
      edit: false,
    };
  },

  watch: {
    value: {
      handler: function(val, oldVal) {
        this.innerValue = val;
        this.$emit("updated", { value: val, context: this.context });
      },
    },
  },
  created() {
    this.innerValue = this.value;
  },
  methods: {
    save() {
      this.edit = false;
      this.$emit("input", this.innerValue);
    },
  },
};
</script>

<style></style>
